/* Haru motion · reveal, tagline por palabra, marquee, momentos, timeline, scroll al buy box y fecha de despacho.
   Vanilla, sin librerías. Respeta prefers-reduced-motion y el editor de temas. */
(function () {
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(w.Shopify && w.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in w;

  /* 1. Reveal de bloques clave */
  var rio = null;
  if (!reduce && !editor && hasIO) {
    d.documentElement.classList.add('hx-rv');
    rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }
  function initReveal(root) {
    if (!rio) return;
    root.querySelectorAll('[data-reveal-group]').forEach(function (g) {
      g.querySelectorAll('[data-reveal]').forEach(function (el, i) { el.style.setProperty('--i', Math.min(i, 6)); });
    });
    root.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) { rio.observe(el); });
  }

  /* 2. Tagline por palabra + 3. timeline: un solo listener de scroll con rAF, activo solo mientras se ven */
  var tracked = [], ticking = false, listening = false;
  function tick() {
    ticking = false;
    var vh = w.innerHeight;
    tracked.forEach(function (t) {
      if (!t.on) return;
      var r = t.el.getBoundingClientRect();
      if (t.type === 'words') {
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        var n = Math.round(p * t.items.length);
        for (var i = 0; i < t.items.length; i++) t.items[i].classList.toggle('is-on', i < n);
      } else {
        var q = Math.min(1, Math.max(0, (vh * 0.62 - r.top) / r.height));
        t.el.style.setProperty('--fill', (q * 100).toFixed(1) + '%');
        for (var j = 0; j < t.items.length; j++) {
          var ir = t.items[j].getBoundingClientRect();
          t.items[j].classList.toggle('is-on', ir.top < vh * 0.62);
        }
      }
    });
  }
  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(tick); } }
  function syncListener() {
    var need = tracked.some(function (t) { return t.on; });
    if (need && !listening) { w.addEventListener('scroll', onScroll, { passive: true }); listening = true; }
    else if (!need && listening) { w.removeEventListener('scroll', onScroll); listening = false; }
  }
  var tio = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      tracked.forEach(function (t) { if (t.el === e.target) t.on = e.isIntersecting; });
    });
    syncListener(); tick();
  }) : null;
  function initTracked(root) {
    root.querySelectorAll('[data-hx-words]').forEach(function (el) {
      var items = el.querySelectorAll('.hx-w');
      if (reduce || editor || !tio) { items.forEach(function (x) { x.classList.add('is-on'); }); return; }
      if (el.dataset.hxBound) return; el.dataset.hxBound = '1';
      tracked.push({ el: el, items: items, type: 'words', on: false }); tio.observe(el);
    });
    root.querySelectorAll('[data-hx-tl]').forEach(function (el) {
      var items = el.querySelectorAll('[data-hx-phase]');
      if (reduce || editor || !tio) { el.style.setProperty('--fill', '100%'); items.forEach(function (x) { x.classList.add('is-on'); }); return; }
      if (el.dataset.hxBound) return; el.dataset.hxBound = '1';
      tracked.push({ el: el, items: items, type: 'tl', on: false }); tio.observe(el);
    });
  }

  /* 4. Marquee: se pausa fuera de pantalla */
  function initMarquee(root) {
    if (!hasIO) return;
    root.querySelectorAll('[data-hx-marquee]').forEach(function (m) {
      new IntersectionObserver(function (es) { m.classList.toggle('is-paused', !es[0].isIntersecting); }).observe(m);
    });
  }

  /* 5. Selector de momentos */
  function initMoments(root) {
    root.querySelectorAll('[data-hx-moments]').forEach(function (box) {
      if (box.dataset.hxBound) return; box.dataset.hxBound = '1';
      var btns = box.querySelectorAll('[data-moment]'), panels = box.querySelectorAll('[data-moment-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-moment-panel') === b.getAttribute('data-moment');
            p.hidden = !on; if (on) { p.classList.remove('is-anim'); void p.offsetWidth; p.classList.add('is-anim'); }
          });
        });
      });
    });
  }

  /* 6. Scroll al buy box (Lumin interrumpe el smooth nativo: animamos a mano) */
  function buyTarget() {
    return d.querySelector('.kaching-bundles') || d.querySelector('product-form') || d.querySelector('.product__info-wrapper') || d.querySelector('[id^="MainProduct"]');
  }
  function scrollToY(y) {
    var root = d.documentElement; root.style.scrollBehavior = 'auto';
    if (reduce) { w.scrollTo(0, y); return; }
    var start = w.pageYOffset, dist = y - start, dur = Math.min(900, Math.max(360, Math.abs(dist) * 0.3)), t0 = Date.now();
    var id = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      w.scrollTo(0, Math.round(start + dist * e)); if (p >= 1) clearInterval(id);
    }, 16);
  }
  d.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#comprar"],[data-hx-buy]');
    if (!a) return;
    var t = buyTarget(); if (!t) return;
    ev.preventDefault();
    var header = d.querySelector('.section-header, sticky-header, .header-wrapper');
    var off = header ? Math.min(header.getBoundingClientRect().height, 120) + 16 : 90;
    scrollToY(t.getBoundingClientRect().top + w.pageYOffset - off);
  });

  /* 7. Despacho: se despacha todos los días hábiles.
        Antes del corte (data-cutoff, hora local) sale el mismo día hábil; después del corte, el siguiente.
        Sábado y domingo se saltan. data-extra suma días hábiles solo si alguna vez hace falta.
        [data-hx-ship-date] recibe la fecha larga; [data-hx-ship-rel] recibe hoy / mañana / el lunes. */
  function initShip(root) {
    root.querySelectorAll('[data-hx-ship]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
      var extra = parseInt(el.getAttribute('data-extra') || '0', 10);
      var now = new Date();
      var dt = new Date();
      if (dt.getHours() >= cutoff) dt.setDate(dt.getDate() + 1);
      while (dt.getDay() === 0 || dt.getDay() === 6) dt.setDate(dt.getDate() + 1);
      var added = 0;
      while (added < extra) { dt.setDate(dt.getDate() + 1); if (dt.getDay() !== 0 && dt.getDay() !== 6) added++; }

      var out = el.querySelector('[data-hx-ship-date]');
      if (out) {
        try { out.textContent = new Intl.DateTimeFormat('es-CL', { weekday: 'long', day: 'numeric', month: 'long' }).format(dt); } catch (e) {}
      }
      var rel = el.querySelector('[data-hx-ship-rel]');
      if (rel) {
        var a = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var b = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        var diff = Math.round((b - a) / 86400000);
        var txt = 'el próximo día hábil';
        if (diff <= 0) txt = 'hoy';
        else if (diff === 1) txt = 'mañana';
        else { try { txt = 'el ' + new Intl.DateTimeFormat('es-CL', { weekday: 'long' }).format(dt); } catch (e) {} }
        rel.textContent = txt;
      }
    });
  }

  function init(root) { initReveal(root); initTracked(root); initMarquee(root); initMoments(root); initShip(root); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();